import React from "react";

function HomePage() {
  return <div>HomePage</div>;
}

export default HomePage;
